module.exports = __webpack_public_path__ + "img/epump_white_logo.ff601d46.svg";